export function slugify(value: unknown): string {
  return String(value ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-zA-Z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '') || '-';
}

export function productId(product: any): any {
  const primitiveFallback = typeof product === 'string' || typeof product === 'number' ? product : undefined;
  return product?.IdProducto
    ?? product?.IdProd
    ?? product?.Modelos?.[0]?.IdProducto
    ?? product?.Modelos?.[0]?.IdProd
    ?? product?.Modelos?.[0]?.Imagenes?.[0]?.IdProd
    ?? primitiveFallback;
}

export function productPath(product: any): string {
  const id = productId(product);
  if (id === undefined || id === null || id === '') return '/productos';

  const slugSource = product?.Ruta || [product?.Marca, product?.Nombre].filter(Boolean).join(' ');
  const slug = slugify(slugSource || `producto-${id}`);
  return `/producto/${slug}`;
}

export function categoryPath(category: any): string {
  const id = category?.IdCategoria ?? category?.IdCat ?? category?.id ?? category;
  const slugSource = category?.Ruta || category?.Categoria || category?.DescCategoria || category?.nombre;
  const slug = slugify(slugSource || `categoria-${id}`);
  return `/categoria/${slug}`;
}
